module.exports = __webpack_public_path__ + "img/Doll2020.a52efac1.jpg";